<template>
  <div class="col-md-12">
    <div class="col-md-4">
      <div class="mb-3">
        <label>Συσκευές</label>
        <b-spinner
          v-show="spinner"
          class="m-2"
          variant="primary"
          role="status"
        ></b-spinner>
        <b-alert
          v-show="alert.alertShow"
          show
          dismissible
          :variant="alert.alertVariant"
          >{{ alert.alertMsg }}</b-alert
        >
        <multiselect
          v-model="deviceSelected"
          :options="deviceNames"
          placeholder="Επιλέξτε Συσκευή"
          selectLabel="Eπιλογή Συσκευή"
          selectedLabel="Επιλέχθηκε"
          deselectLabel="Αποεπιλογή"
        ></multiselect>
      </div>
      <div class="col-xl-12">
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <button class="btn btn-primary" @click.prevent="getDeviceUsers">
                Χρήστες Συσκευής
              </button>
            </div>
          </div>

          <div class="col-md-6">
            <div class="mb-3">
              <button
                class="btn btn-primary"
                @click.prevent="getDeviceUserAttendances"
              >
                Παρουσίες Συσκευής
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-6" v-if="is_superuser">
        <div class="mb-3">
          <button
            class="btn btn-danger"
            @click.prevent="deleteUsersFromClockSwal"
          >
            Διαγραφή Χρηστών Από Συσκευή
          </button>
        </div>
      </div>
    </div>
    <div class="col-xl-12" v-if="isFethingDeviceUsers">
      <DeviceUsers :deviceUsers="deviceUsers"></DeviceUsers>
    </div>
    <div class="col-xl-12" v-if="isFetchinDeviceAttendances">
      <DeviceAttendances :deviceUserAttendances="deviceUserAttendances">
      </DeviceAttendances>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import DeviceUsers from "./DeviceUsers.vue";
import { mapGetters } from "vuex";
import session from "../../../../../api/session";
import DeviceAttendances from "./DeviceAttendances.vue";
import Swal from "sweetalert2";

export default {
  name: "SecondTab",
  props: {
    devices: {
      type: Array,
      required: true,
    },
  },
  components: {
    Multiselect,
    DeviceUsers,
    DeviceAttendances,
  },
  data() {
    return {
      deviceSelected: "",
      isFethingDeviceUsers: false,
      deviceUsers: [],
      deviceUserAttendances: [],
      isFetchinDeviceAttendances: false,

      spinner: false,
      alert: {
        alertShow: false,
        alertVariant: "",
        alertMsg: "",
      },
    };
  },
  computed: {
    deviceNames() {
      return this.devices.map((e) => e.device_name);
    },
    ...mapGetters("auth", ["is_superuser"]),
  },

  methods: {
    async getDeviceUsers() {
      if (this.deviceSelected === "" || this.deviceSelected == null) {
        this.alert.alertShow = true;
        this.alert.alertVariant = "danger";
        this.alert.alertMsg = "Παρακαλώ επιλέξτε συσκευή";
        setTimeout(() => {
          this.alert.alertShow = false;
        }, 2000);
        return;
      }
      this.isFetchinDeviceAttendances = false;
      this.deviceUsers = [];
      this.spinner = true;
      await session
        .get(
          `api/devices/people/?device_name=${this.deviceSelected}&all_users=true`
        )
        .then((resp) => {
          this.deviceUsers = resp.data;

          this.isFethingDeviceUsers = true;
          this.spinner = false;
        })
        .catch((e) => {
          console.log(e.response.data);
          this.spinner = false;
          this.alert.alertShow = true;
          this.alert.alertVariant = "danger";
          this.alert.alertMsg = e.response.data;
          setTimeout(() => {
            this.alert.alertShow = false;
          }, 2000);
          return;
        });
    },
    async getDeviceUserAttendances() {
      this.deviceUserAttendances = [];
      this.spinner = true;
      this.isFethingDeviceUsers = false;
      await session
        .get(
          `api/devices/people/?device_name=${this.deviceSelected}&attendances=true`
        )
        .then((resp) => {
          this.deviceUserAttendances = resp.data;
          this.isFetchinDeviceAttendances = true;
          this.spinner = false;
        })
        .catch((e) => {
          console.log(e.response.data);
          this.spinner = false;
          this.alert.alertShow = true;
          this.alert.alertVariant = "danger";
          this.alert.alertMsg = e.response.data;
          setTimeout(() => {
            this.alert.alertShow = false;
          }, 2000);
          return;
        });
    },
    deleteUsersFromClockSwal() {
      if (this.deviceSelected === "" || this.deviceSelected == null) {
        this.alert.alertShow = true;
        this.alert.alertVariant = "danger";
        this.alert.alertMsg = "Παρακαλώ επιλέξτε συσκευή";
        setTimeout(() => {
          this.alert.alertShow = false;
        }, 2000);
        return;
      }
      Swal.fire({
        title: "Είστε σίγουρος;",
        text: "Δεν θα μπορείτε να το επαναφέρετε!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι, διαγράψτε το!",
      }).then((result) => {
        if (result.value) {
          const usersAreDeleted = this.deleteUsersFromClock();
          if (usersAreDeleted) {
            Swal.fire(
              "Διαγράφηκε!",
              `Γίνεται διαγραφή χρηστών απο το ρολόι ${this.deviceSelected}... Ελέγξτε το σε λίγο`,
              "success"
            );
          } else {
            Swal.fire("Ουπς", "Συνέβη κάποιο σφάλμα.", "danger");
          }
        }
      });
    },
    async deleteUsersFromClock() {
      this.spinnerShow = true;
      this.isFethingDeviceUsers = false;
      this.isFetchinDeviceAttendances = false;

      await session
        .get(`api/delete-users/clock/?device_name=${this.deviceSelected}`)
        .then(() => {
          this.spinner = false;

          setTimeout(() => {
            this.alert.alertShow = false;
          }, 2000);
          return true;
        })
        .catch((e) => {
          console.log(e.response.data);
          this.spinner = false;

          setTimeout(() => {
            this.alert.alertShow = false;
          }, 2000);
          return false;
        });
    },
  },
};
</script>
